export default {
  building: "Building",
  private_home: "Private Home",
}